import React from 'react';


const ArrowBack = ({width, height, color}) => {
    const getColor = (c) => {
        if (c === 'primary-500') return '#7F0689';
        if (c === 'secondary-500') return '#75D3A8';
        return c;
    };
    return (
        <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 8H1M1 8L8 15M1 8L8 1" stroke={getColor(color) || '#6E6C6C'} strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    );
};
export default ArrowBack;
